export const redirectToLinkDiscord: Function = () => {
	const applicationId: string = '1098056685727252510';
	const redirectUri: string = `${location.origin}/discord-callback`;
	const responseType: string = 'token';
	const scopes: string[] = ['identify'];
	const url: string = `https://discord.com/api/oauth2/authorize?client_id=${applicationId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${responseType}&scope=${scopes.join('+')}`;
	window.open(url, '_blank');
};
